import { render } from "./Painting.vue?vue&type=template&id=61a90a67&scoped=true"
import script from "./Painting.vue?vue&type=script&lang=js"
export * from "./Painting.vue?vue&type=script&lang=js"

import "./Painting.vue?vue&type=style&index=0&id=61a90a67&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a90a67"]])

export default __exports__